import fecha from "fecha";
import { find } from "@/utils/";

function checkTimes(times) {
    if (('' + times).length <= 10) {
        times = parseInt(times) * 1000;
    }
    return parseInt(times);
}

export function serializeDate({ date = 0, month = 0, year = 0, hour = 0, minute = 0, second = 0 }) {
    return (now) => {
        var result = new Date(now);
        result.setFullYear(result.getFullYear() + year);
        result.setMonth(result.getMonth() + month);
        result.setDate(result.getDate() + date);
        result.setHours(result.getHours() + hour);
        result.setMinutes(result.getMinutes() + minute);
        result.setSeconds(result.getSeconds() + second);
        return result;
    }
}

export default function (Vue) {
    Vue.filter('videoTime', function (val) {
        val = parseInt(val);
        const padNumber = Vue.filter('padNumber');
        return padNumber(parseInt(val / 60, 10), 2) + ':' + padNumber(val % 60, 2);
    });

    Vue.filter('padNumber', function (val, size) {
        var s = "000000000" + val;
        return s.substr(s.length - size);
    });

    Vue.filter('timesify', function (source, format) {
        if(typeof source === "undefined" || !source) return "";
        var date = source;
        if (source.constructor !== Date) {
            try {
                date = fecha.parse(source, 'YYYY-MM-DD HH:mm:ss')
            }catch (e){
                return ""
            }
        }

        var now = new Date();
        var yesterday = {
            start: serializeDate({ date: -1 })(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0)),
            end: new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0)
        };
        var today = {
            start: new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0),
            end: new Date(now.getFullYear(), now.getMonth(), now.getDate(), 24, 0, 0, 0)
        }
        var thisyear = {
            start: new Date(now.getFullYear(), 1, 1, 0, 0, 0, 0),
            end: serializeDate({ date: -1 })(new Date(now.getFullYear() + 1, 1, 1, 0, 0, 0, 0))
        }
        var formatStr = format ? format : (date.getTime() > thisyear.start.getTime() && date.getTime() < thisyear.end.getTime() ? 'MM/DD HH:mm' : 'YYYY/MM/DD HH:mm');
        // var diff = now.getTime() - date.getTime();

        // diff = Math.floor(diff / 60 / 1000);
        // if(diff > 0 && diff <= 30) return '刚刚';
        // if(diff > 30 && diff <= 60) return '1小时前';
        // if(diff > 60 && diff <= 120) return '2小时前';
        // if(diff > 120 && diff <= 180) return '3小时前';
        if (date.getTime() > yesterday.start.getTime() && date.getTime() < yesterday.end.getTime()) return fecha.format(date, '昨天 HH:mm');
        if (date.getTime() > today.start.getTime() && date.getTime() < today.end.getTime()) return fecha.format(date, 'HH:mm');
        return fecha.format(date, formatStr);
    });
    Vue.filter('datetime', function (source, format) {
        if(typeof source === "undefined" || !source) return "";
        var date = source;
        if (source.constructor !== Date) {
            try {
                date = fecha.parse(source, 'YYYY-MM-DD HH:mm:ss')
            }catch (e){
                return ""
            }
        }
        var formatStr = format ? format : 'YYYY/MM/DD HH:mm:ss';
        return fecha.format(date, formatStr);
    })

    Vue.filter('default', function(source, defaultVal='--'){
        return !!source ? source : defaultVal
    })

    Vue.filter('find', function(...args){
        return find(...args)
    })

    Vue.filter('field', function(source, fieldName){
        return source[fieldName] || ""
    })

    Vue.filter('map', function(source, funName, ...args){
      const fun = Vue.filter(funName)
      return source.map(val=>fun(val,...args))
    })

    Vue.filter('join', function(source, split=","){
      return source.join(split)
    })
}
